import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter038() {
  return <KbChapterPage slug="chapter-038" />;
}

(Chapter038 as unknown as { path: string }).path = "/theory-album/038";
